// extracted by mini-css-extract-plugin
export default {"instructionsContainer":"EK-z","instructionsColumn":"FK-z","columnTitle":"GK-z","secondLine":"HK-z"};